import { parseMoney } from '@/shared/lib/money';
import type { CompraListItem } from '../api';

/**
 * Lo que todavía se le debe al proveedor. Misma fórmula en toda la app
 * (listado de Compras, Ver Compra, Cuentas por Pagar): las Notas de Crédito
 * pendientes descuentan en pantalla porque el flujo de pago las absorbe al
 * promover la compra a Pagado.
 *
 * De las retenciones descuenta sólo `importeRetencionesPendientes`: las que
 * ya se imputaron a un pago viajan dentro de `importePagado` (`Importe_PC` =
 * instrumentos + retenciones), y restar el total las contaba dos veces.
 *
 * Vive acá y no en `api.ts` para poder correrla sin arrastrar el cliente HTTP
 * (`saldo.selfcheck.ts`).
 */
export function saldoRestante(row: CompraListItem): number {
  const total = parseMoney(row.fields.Total_CO) ?? 0;
  return Math.max(
    0,
    total -
      row.importePagado -
      row.importeRetencionesPendientes -
      row.importeNotasCreditoPendientes,
  );
}

/**
 * Saldo pendiente partido por moneda, para el footer de Cuentas por Pagar.
 * El listado ya viene scopeado por país, así que "todo lo que no es Dólares"
 * es la moneda local sin ambigüedad.
 */
export function totalesRestantePorMoneda(rows: CompraListItem[]): {
  pesos: number;
  dolares: number;
} {
  let pesos = 0;
  let dolares = 0;
  for (const r of rows) {
    if (r.fields.Moneda_CO === 'Dolares') dolares += saldoRestante(r);
    else pesos += saldoRestante(r);
  }
  return { pesos, dolares };
}
